import { useState, useCallback, useMemo } from 'react';

// Универсальный хук множественного выбора для списков.
export default function useMultiSelect() {
    const [selectMode, setSelectMode] = useState(false);
    const [selected, setSelected] = useState(() => new Set());

    const isSelected = useCallback((id) => selected.has(id), [selected]);

    const toggle = useCallback((id) => {
        setSelected(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);

    const selectAll = useCallback((ids) => setSelected(new Set(ids)), []);
    const clear = useCallback(() => setSelected(new Set()), []);

    const exitSelectMode = useCallback(() => {
        setSelectMode(false);
        setSelected(new Set());
    }, []);

    const ids = useMemo(() => Array.from(selected), [selected]);

    return {
        selectMode, setSelectMode,
        isSelected, toggle, selectAll, clear, exitSelectMode,
        count: selected.size, ids,
    };
}